(function () {
  'use strict';

  function initHeaderSliders() {
    document.querySelectorAll('[data-header-slider]').forEach(function (slider) {
      var slides = Array.from(slider.querySelectorAll('.header-media__slide'));
      var indicators = Array.from(slider.querySelectorAll('.header-slider-indicator'));
      var controls = slider.querySelector('.header-slider-controls');
      if (slides.length < 2 || indicators.length !== slides.length || !controls) return;

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var duration = Number(slider.getAttribute('data-interval')) || 6000;
      var active = 0;
      var elapsed = 0;
      var previousTime = null;
      var frame = null;
      var paused = reducedMotion.matches;
      var visible = true;
      var keyboardFocus = false;

      // Warm the responsive sources so crossfades do not reveal an unloaded image.
      slides.forEach(function (slide) { slide.querySelector('img').loading = 'eager'; });

      function paint() {
        var progress = Math.min(elapsed / duration, 1);
        indicators.forEach(function (indicator, index) {
          indicator.querySelector('.header-slider-indicator__fill').style.transform =
            'scaleX(' + (index < active ? 1 : index === active ? progress : 0) + ')';
          indicator.setAttribute('aria-current', index === active ? 'true' : 'false');
        });
        slides[active].querySelector('img').style.transform =
          'scale(' + (reducedMotion.matches ? 1 : 1.08 - progress * 0.08) + ')';
      }

      function selectSlide(index) {
        active = (index + slides.length) % slides.length;
        elapsed = 0;
        previousTime = null;
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === active);
        });
        paint();
      }

      function tick(time) {
        if (previousTime !== null) elapsed += time - previousTime;
        previousTime = time;
        if (elapsed >= duration) {
          var nextImage = slides[(active + 1) % slides.length].querySelector('img');
          if (nextImage.complete) selectSlide(active + 1);
        }
        paint();
        frame = window.requestAnimationFrame(tick);
      }

      function syncPlayback() {
        if (frame !== null) window.cancelAnimationFrame(frame);
        frame = null;
        previousTime = null;
        if (!paused && !document.hidden && visible && !keyboardFocus) {
          frame = window.requestAnimationFrame(tick);
        }
      }

      indicators.forEach(function (indicator, index) {
        indicator.addEventListener('click', function () { selectSlide(index); });
        indicator.addEventListener('keydown', function (event) {
          var target;
          if (event.key === 'ArrowRight') target = (index + 1) % slides.length;
          if (event.key === 'ArrowLeft') target = (index + slides.length - 1) % slides.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = slides.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          indicators[target].focus();
          selectSlide(target);
        });
      });

      slider.addEventListener('focusin', function (event) {
        keyboardFocus = event.target.matches(':focus-visible');
        syncPlayback();
      });
      slider.addEventListener('focusout', function (event) {
        if (!slider.contains(event.relatedTarget)) {
          keyboardFocus = false;
          syncPlayback();
        }
      });
      document.addEventListener('visibilitychange', syncPlayback);
      reducedMotion.addEventListener('change', function () {
        paused = reducedMotion.matches;
        paint();
        syncPlayback();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          syncPlayback();
        }).observe(slider);
      }

      controls.hidden = false;
      paint();
      syncPlayback();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderSliders);
  } else {
    initHeaderSliders();
  }
}());
